import CourseChapter from 'src/model/CourseChapter';

const courseChapterDatabaseMap: Map<string, CourseChapter> = new Map<string, CourseChapter>([
  [
    'dynamic_programming',
    {
      courseChapterId: 'dynamic_programming',
      courseId: 'coding_interview',
      title: 'Dynamic Programming',
      number: 1,
    },
  ],
  [
    'graph',
    {
      courseChapterId: 'graph',
      courseId: 'coding_interview',
      title: 'Graph',
      number: 2,
    },
  ],
  [
    'stack',
    {
      courseChapterId: 'stack',
      courseId: 'coding_interview',
      title: 'Stack',
      number: 3,
    },
  ],
  [
    'algorithm',
    {
      courseChapterId: 'algorithm',
      courseId: 'coding_interview',
      title: 'Algorithm',
      number: 4,
    },
  ],
  [
    'coming_soon',
    {
      courseChapterId: 'coming_soon',
      courseId: 'coming_soon',
      title: 'Coming Soon',
      number: 1,
    },
  ],
]);

export default courseChapterDatabaseMap;
